import { DependencyList, EffectCallback, useEffect, useRef } from "react";

function useUpdateEffect(
  callback: EffectCallback,
  dependencies?: DependencyList
) {
  const componentJustMounted = useRef(true);

  useEffect(() => {
    if (!componentJustMounted.current) {
      callback();
    }
    componentJustMounted.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}

export default useUpdateEffect;
